import React from 'react';

import { CheckOutlined } from '@mui/icons-material';
import { List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';

import { OrderAccessRoleLabel, ROLE_ACTIONS } from '~/consts/orderAccess';

import Modal from './Modal';

interface RoleActionsModalProps {
  open: boolean;
  onClose: () => void;
  role: App.OrderAccessRole;
  title?: string;
}

export default function RoleActionsModal({ open, onClose, role }: RoleActionsModalProps) {
  const displayRole = OrderAccessRoleLabel[role];
  const actions = ROLE_ACTIONS[role] || [];
  const article = displayRole === 'Editor' ? 'an' : 'a';

  return (
    <Modal open={open} onClose={onClose} title={displayRole}>
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          As {article} {displayRole}, they are able to:
        </Typography>
        <List>
          {actions.map((action) => (
            <ListItem key={action.id} alignItems="flex-start">
              <ListItemIcon>
                <CheckOutlined fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={action.label} secondary={action.description ? action.description : null} />
            </ListItem>
          ))}
        </List>
      </Stack>
    </Modal>
  );
}
